import {
  required,
  trimError,
  isFirstCharInUpperCase,
  onlyLettersAndHyphen,
  noHyphenStartOrEnd,
  noSpaceStart,
  maxLength500,
  noSpaceEnd, onlyCyrillicAlphabet,
} from '../utils/validation';
import DTO from './DTO';

class FIODTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'last_name',
        type: String,
        validators: [params?.optional ? () => {} : required, maxLength500, isFirstCharInUpperCase, trimError, noHyphenStartOrEnd, noSpaceStart, noSpaceEnd, onlyCyrillicAlphabet],
        labelKey: 'last_name',
      },
      {
        name: 'first_name',
        type: String,
        validators: [params?.optional ? () => {} : required, maxLength500, isFirstCharInUpperCase, trimError, noHyphenStartOrEnd, noSpaceStart, noSpaceEnd, onlyCyrillicAlphabet],
        labelKey: 'first_name',
      },
      {
        name: 'middle_name',
        type: String,
        validators: [maxLength500, isFirstCharInUpperCase, trimError, noHyphenStartOrEnd, noSpaceStart, noSpaceEnd, onlyCyrillicAlphabet],
        labelKey: 'middle_name',
      },
      {
        name: 'fio_change_document',
        type: String,
        validators: [],
        labelKey: 'media.fio_change_document',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      last_name: this.last_name ? String(this.last_name).trim() : this.last_name,
      first_name: this.first_name ? String(this.first_name).trim() : this.first_name,
      middle_name: this.middle_name ? String(this.middle_name).trim() : this.middle_name,
    };
  }
}

export default FIODTO;
